import NewVideoRequest from 'src/adminPanel/entities/it/videos/NewVideoRequest';
import VideoRatingFilter from 'src/adminPanel/entities/it/videos/VideoRatingFilter';
import { PageableQueryParams } from 'src/entities/basic-types/Pageable';
import { action } from 'src/store/actions';

/* Video Topics */
export const FETCH_VIDEO_TOPICS_ADMIN = 'FETCH_VIDEO_TOPICS_ADMIN';
export const REQUEST_VIDEO_TOPICS_ADMIN = 'REQUEST_VIDEO_TOPICS_ADMIN';
export const SUCCESS_VIDEO_TOPICS_ADMIN = 'SUCCESS_VIDEO_TOPICS_ADMIN';
export const FAILURE_VIDEO_TOPICS_ADMIN = 'FAILURE_VIDEO_TOPICS_ADMIN';

export const fetchVideoTopicsAdmin = () => action(FETCH_VIDEO_TOPICS_ADMIN);
export const requestVideoTopicsAdmin = () => action(REQUEST_VIDEO_TOPICS_ADMIN);
export const requestVideoTopicsAdminSuccess = (response: any) => action(SUCCESS_VIDEO_TOPICS_ADMIN, { response });
export const requestVideoTopicsAdminFailure = (error: any) => action(FAILURE_VIDEO_TOPICS_ADMIN, { error });

/* Video Categories by topic */
export const FETCH_VIDEO_CATEGORIES_BY_TOPICID_ADMIN = 'FETCH_VIDEO_CATEGORIES_BY_TOPICID_ADMIN';
export const REQUEST_VIDEO_CATEGORIES_BY_TOPICID_ADMIN = 'REQUEST_VIDEO_CATEGORIES_BY_TOPICID_ADMIN';
export const SUCCESS_VIDEO_CATEGORIES_BY_TOPICID_ADMIN = 'SUCCESS_VIDEO_CATEGORIES_BY_TOPICID_ADMIN';
export const FAILURE_VIDEO_CATEGORIES_BY_TOPICID_ADMIN = 'FAILURE_VIDEO_CATEGORIES_BY_TOPICID_ADMIN';

export const fetchVideoCategoriesByTopicIdAdmin = (topicId: string) =>
    action(FETCH_VIDEO_CATEGORIES_BY_TOPICID_ADMIN, { topicId });
export const requestVideoCategoriesByTopicIdAdmin = () => action(REQUEST_VIDEO_CATEGORIES_BY_TOPICID_ADMIN);
export const requestVideoCategoriesByTopicIdAdminSuccess = (response: any) =>
    action(SUCCESS_VIDEO_CATEGORIES_BY_TOPICID_ADMIN, { response });
export const requestVideoCategoriesByTopicIdAdminFailure = (error: any) =>
    action(FAILURE_VIDEO_CATEGORIES_BY_TOPICID_ADMIN, { error });

/* Videos without Category Admin */
export const FETCH_VIDEOS_WITHOUT_CATEGORY_ADMIN = 'FETCH_VIDEOS_WITHOUT_CATEGORY_ADMIN';
export const REQUEST_VIDEOS_WITHOUT_CATEGORY_ADMIN = 'REQUEST_VIDEOS_WITHOUT_CATEGORY_ADMIN';
export const SUCCESS_VIDEOS_WITHOUT_CATEGORY_ADMIN = 'SUCCESS_VIDEOS_WITHOUT_CATEGORY_ADMIN';
export const FAILURE_VIDEOS_WITHOUT_CATEGORY_ADMIN = 'FAILURE_VIDEOS_WITHOUT_CATEGORY_ADMIN';

export const fetchVideosWithoutCategoryAdmin = () => action(FETCH_VIDEOS_WITHOUT_CATEGORY_ADMIN);
export const requestVideosWithoutCategoryAdmin = () => action(REQUEST_VIDEOS_WITHOUT_CATEGORY_ADMIN);
export const requestVideosWithoutCategoryAdminSuccess = (response: any) =>
    action(SUCCESS_VIDEOS_WITHOUT_CATEGORY_ADMIN, { response });
export const requestVideosWithoutCategoryAdminFailure = (error: any) =>
    action(FAILURE_VIDEOS_WITHOUT_CATEGORY_ADMIN, { error });

/* Videos By Category Admin */
export const FETCH_VIDEOS_BY_CATEGORY_ADMIN = 'FETCH_VIDEOS_BY_CATEGORY_ADMIN';
export const REQUEST_VIDEOS_BY_CATEGORY_ADMIN = 'REQUEST_VIDEOS_BY_CATEGORY_ADMIN';
export const SUCCESS_VIDEOS_BY_CATEGORY_ADMIN = 'SUCCESS_VIDEOS_BY_CATEGORY_ADMIN';
export const FAILURE_VIDEOS_BY_CATEGORY_ADMIN = 'FAILURE_VIDEOS_BY_CATEGORY_ADMIN';

export const fetchVideosByCategoryAdmin = (videoCategoryId: string) =>
    action(FETCH_VIDEOS_BY_CATEGORY_ADMIN, { videoCategoryId });
export const requestVideosByCategoryAdmin = () => action(REQUEST_VIDEOS_BY_CATEGORY_ADMIN);
export const requestVideosByCategoryAdminSuccess = (response: any) =>
    action(SUCCESS_VIDEOS_BY_CATEGORY_ADMIN, { response });
export const requestVideosByCategoryAdminFailure = (error: any) => action(FAILURE_VIDEOS_BY_CATEGORY_ADMIN, { error });

/* Video Categories  */
export const FETCH_VIDEO_CATEGORIES_ADMIN = 'FETCH_VIDEO_CATEGORIES_ADMIN';
export const REQUEST_VIDEO_CATEGORIES_ADMIN = 'REQUEST_VIDEO_CATEGORIES_ADMIN';
export const SUCCESS_VIDEO_CATEGORIES_ADMIN = 'SUCCESS_VIDEO_CATEGORIES_ADMIN';
export const FAILURE_VIDEO_CATEGORIES_ADMIN = 'FAILURE_VIDEO_CATEGORIES_ADMIN';

export const fetchVideoCategoriesAdmin = () => action(FETCH_VIDEO_CATEGORIES_ADMIN);
export const requestVideoCategoriesAdmin = () => action(REQUEST_VIDEO_CATEGORIES_ADMIN);
export const requestVideoCategoriesAdminSuccess = (response: any) =>
    action(SUCCESS_VIDEO_CATEGORIES_ADMIN, { response });
export const requestVideoCategoriesAdminFailure = (error: any) => action(FAILURE_VIDEO_CATEGORIES_ADMIN, { error });

/* create new Video  */
export const CREATE_NEW_VIDEO_ADMIN = 'CREATE_NEW_VIDEO_ADMIN';
export const REQUEST_CREATE_NEW_VIDEO_ADMIN = 'REQUEST_CREATE_NEW_VIDEO_ADMIN';
export const SUCCESS_CREATE_NEW_VIDEO_ADMIN = 'SUCCESS_CREATE_NEW_VIDEO_ADMIN';
export const FAILURE_CREATE_NEW_VIDEO_ADMIN = 'FAILURE_CREATE_NEW_VIDEO_ADMIN';

export const createNewVideoAdmin = (newVideoRequest: NewVideoRequest) =>
    action(CREATE_NEW_VIDEO_ADMIN, { newVideoRequest });
export const requestCreateNewVideoAdmin = () => action(REQUEST_CREATE_NEW_VIDEO_ADMIN);
export const requestCreateNewVideoAdminSuccess = (response: any) =>
    action(SUCCESS_CREATE_NEW_VIDEO_ADMIN, { response });
export const requestCreateNewVideoAdminFailure = (error: any) => action(FAILURE_CREATE_NEW_VIDEO_ADMIN, { error });

/* edit Video  */
export const EDIT_VIDEO_ADMIN = 'EDIT_VIDEO_ADMIN';
export const REQUEST_EDIT_VIDEO_ADMIN = 'REQUEST_EDIT_VIDEO_ADMIN';
export const SUCCESS_EDIT_VIDEO_ADMIN = 'SUCCESS_EDIT_VIDEO_ADMIN';
export const FAILURE_EDIT_VIDEO_ADMIN = 'FAILURE_EDIT_VIDEO_ADMIN';

export const editVideoAdmin = (newVideoRequest: NewVideoRequest) => action(EDIT_VIDEO_ADMIN, { newVideoRequest });
export const requestEditVideoAdmin = () => action(REQUEST_EDIT_VIDEO_ADMIN);
export const requestEditVideoAdminSuccess = (response: any) => action(SUCCESS_EDIT_VIDEO_ADMIN, { response });
export const requestEditVideoAdminFailure = (error: any) => action(FAILURE_EDIT_VIDEO_ADMIN, { error });

/* Video Ratings */
export const FETCH_VIDEO_RATINGS_ADMIN = 'FETCH_VIDEO_RATINGS_ADMIN';
export const REQUEST_VIDEO_RATINGS_ADMIN = 'REQUEST_VIDEO_RATINGS_ADMIN';
export const SUCCESS_VIDEO_RATINGS_ADMIN = 'SUCCESS_VIDEO_RATINGS_ADMIN';
export const FAILURE_VIDEO_RATINGS_ADMIN = 'FAILURE_VIDEO_RATINGS_ADMIN';

export const fetchVideoRatingsAdmin = (videoId: string, filter: VideoRatingFilter, pageable?: PageableQueryParams) =>
    action(FETCH_VIDEO_RATINGS_ADMIN, { videoId, filter, pageable });
export const requestVideoRatingsAdmin = () => action(REQUEST_VIDEO_RATINGS_ADMIN);
export const requestVideoRatingsAdminSuccess = (response: any) => action(SUCCESS_VIDEO_RATINGS_ADMIN, { response });
export const requestVideoRatingsAdminFailure = (error: any) => action(FAILURE_VIDEO_RATINGS_ADMIN, { error });
